var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Input } from '../../form/Input';
var MAP_SIZE_TO_ICON_STYLES = {
    md: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 1.86rem;\n    height: 1.86rem;\n    margin-right: 0.5rem;\n  "], ["\n    width: 1.86rem;\n    height: 1.86rem;\n    margin-right: 0.5rem;\n  "]))),
    lg: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 3rem;\n    height: 3rem;\n  "], ["\n    width: 3rem;\n    height: 3rem;\n  "]))),
};
var InputIconStyled = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n\n  input {\n    padding-right: 3.14rem;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n\n  input {\n    padding-right: 3.14rem;\n  }\n"])));
var IconWrapper = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  position: absolute;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  font-size: 1rem;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 50%;\n  }\n\n  svg {\n    max-width: 1.3rem;\n    max-height: 1.3rem;\n    color: #555;\n  }\n"], ["\n  ", "\n  position: absolute;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  font-size: 1rem;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 50%;\n  }\n\n  svg {\n    max-width: 1.3rem;\n    max-height: 1.3rem;\n    color: #555;\n  }\n"])), function (_a) {
    var inputSize = _a.inputSize;
    return MAP_SIZE_TO_ICON_STYLES[inputSize];
});
export var InputIcon = function (_a) {
    var Icon = _a.Icon, onAction = _a.onAction, _b = _a.inputSize, inputSize = _b === void 0 ? 'lg' : _b, inputProps = _a.inputProps, buttonProps = _a.buttonProps, props = __rest(_a, ["Icon", "onAction", "inputSize", "inputProps", "buttonProps"]);
    return (<InputIconStyled {...props}>
      <Input data-testid={"input-".concat(props.type)} inputSize={inputSize} {...inputProps}/>
      <IconWrapper inputSize={inputSize} onClick={function (event) {
            event.preventDefault();
            onAction && onAction(event);
        }} {...buttonProps}>
        {Icon}
      </IconWrapper>
    </InputIconStyled>);
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
